import { isEmpty } from 'lodash'
import * as f from "./contants"

export default function processQuestion(product, question, answers) {
    switch (question) {
        default:
        case f.DIALYSIS:
            return respondDialysis(question, answers);
        case f.RETURNING:
            return f.NEXT
        case f.RESIDENCY:
            return respondResidency(question, answers);
        case f.HOUSEHOLDSIZE:
            return respondHouseholdSize(question, answers);
        case f.INCOMELEVEL:
            return respondIncomeLevel(product, question, answers);
        case f.INSURANCE:
            return respondInsurance(product, question, answers)
        case f.COVERAGE:
            return respondCoverage(question, answers)
    }
}

function respondDialysis(question, answers) {
    var n = answers.filter(function (answer) {
        return answer.name === question
    })[0];

    return isEmpty(n) ? f.ERROR : n.options.checkedYes ? f.NEXT : n.options.checkedNo ? f.DENIED : f.ERROR
}

function respondResidency(question, answers) {
    
    var n = answers.filter(function (answer) {
        return answer.name === question
    })[0];

    if (isEmpty(n))
        return f.ERROR;
    if (n.options.checkedNo)
        return f.DENIED;
    if (n.options.checkedYes) {
        var r = Object.keys(n.options.qualification).filter(function (e) {
            return !0 === n.options.qualification[e]
        })[0];

        return isEmpty(r) ? f.ERROR : f.NEXT
    }
}

function respondHouseholdSize(question, answers) {
    var n = answers.filter(function (answer) {
        return answer.name === question
    })[0];

    return isEmpty(n) ? f.ERROR : parseInt(n.options.checkedValue) > 0 ? f.NEXT : f.ERROR
}

function respondIncomeLevel(product, question, answers) {
    var n = answers.filter(function (answer) {
        return answer.name === question
    })[0];

    let respondQuestion = isEmpty(n) ? f.ERROR : n.options.checkedYes ? null : n.options.checkedNo ? f.DENIED : f.ERROR
    if (null !== respondQuestion) {
        return respondQuestion;
    }

    if (product.name !== 'enbrel') {
        return f.NEXT;
    }

    var returnAnswer = answers.filter(function(answer) {
        return answer.name === 'Returning'
    })[0];

    return isEmpty(returnAnswer) ? f.ERROR : returnAnswer.options.checkedYes ? f.NEXT : returnAnswer.options.checkedNo ? f.NEXT2 : f.ERROR
}

function respondCoverage(question, answers) {
    var n = answers.filter(function (answer) {
        return answer.name === question
    })[0];

    return isEmpty(n) ? f.ERROR : n.options.checkedYes ? f.DENIED : n.options.checkedNo ? f.ELIGIBLE : f.ERROR
}

function respondInsurance(e, t, n) {
    var r = e.group
        , o = n.filter(function (e) {
            return e.name === t
        })[0];

    if (isEmpty(o))
        return f.ERROR;
    var i = Object.keys(o.options).filter(function (e) {
        return !0 === o.options[e] && "checkedCommercialYes" !== e && "checkedCommercialNo" !== e && "checkedPartABDYes" !== e && "checkedPartABDNo" !== e && "checkedPartABDSubYes" !== e && "checkedPartABDSubNo" !== e && "checkedPartABDSub2Yes" !== e && "checkedPartABDSub2No" !== e
    });

    if (isEmpty(i))
        return f.ERROR;

    var a = {};
    switch (r) {
        default:
        case 1:
            a = {
                checkedCommercial: !0,
                checkedPartA: !1,
                checkedPartAB: !1,
                checkedPartABD: !1,
                checkedMedicaid: !0,
                checkedOther: !1,
                checkedNone: !0
            }
            if (i.indexOf("checkedCommercial") > -1) {
                if (!o.options.checkedCommercialYes && !o.options.checkedCommercialNo)
                    return f.ERROR;
                if (o.options.checkedCommercialYes)
                    return f.DENIED
            }
            for (var u = 0; u < i.length; u++) {
                if (!a[i[u]])
                    switch (i[u]) {
                        case "checkedPartAB":
                        case "checkedPartABD":
                        case "checkedOther":
                            return f.DENIED1;
                        default:
                            return f.DENIED
                    }
            }
            return f.ELIGIBLE;
        case 2:
            a = {
                checkedCommercial: !0,
                checkedPartA: !0,
                checkedPartAB: !1,
                checkedPartABD: !1,
                checkedMedicaid: !0,
                checkedOther: !1,
                checkedNone: !0
            }
            if (i.indexOf("checkedCommercial") > -1) {
                if (!o.options.checkedCommercialYes && !o.options.checkedCommercialNo)
                    return f.ERROR;
                if (o.options.checkedCommercialYes)
                    return f.DENIED
            }
            for (var s = 0; s < i.length; s++) {
                if (!a[i[s]])
                    switch (i[s]) {
                        case "checkedPartAB":
                        case "checkedPartABD":
                        case "checkedOther":
                            return f.DENIED1;
                        default:
                            return f.DENIED
                    }
            }
            return f.ELIGIBLE;
        case 3:
            a = {
                checkedCommercial: !0,
                checkedPartA: !0,
                checkedPartAB: !0,
                checkedPartABD: !0,
                checkedMedicaid: !1,
                checkedOther: !1,
                checkedNone: !0
            }
            
            if (i.indexOf("checkedCommercial") > -1) {
                if (!o.options.checkedCommercialYes && !o.options.checkedCommercialNo)
                    return f.ERROR;
                if (o.options.checkedCommercialYes)
                    return f.DENIED
            }
            if (i.indexOf("checkedPartABD") > -1) {
                if (!o.options.checkedPartABDYes && !o.options.checkedPartABDNo)
                    return f.ERROR;
                if (o.options.checkedPartABDYes) {
                    if (!o.options.checkedPartABDSubYes && !o.options.checkedPartABDSubNo)
                        return f.ERROR;
                    if (!o.options.checkedPartABDSubYes)
                        return f.DENIED2;
                    if (!o.options.checkedPartABDSub2Yes && !o.options.checkedPartABDSub2No)
                        return f.ERROR;
                    if (o.options.checkedPartABDSub2No)
                        return f.DENIED3
                } else {
                    if (!o.options.checkedPartABDSub2Yes && !o.options.checkedPartABDSub2No)
                        return f.ERROR;
                    if (o.options.checkedPartABDSub2No)
                        return f.DENIED3
                }
            }
            for (var l = 0; l < i.length; l++) {
                if (!a[i[l]])
                    switch (i[l]) {
                        case "checkedOther":
                            return f.DENIED1;
                        default:
                            return f.DENIED
                    }
            }
            return f.ELIGIBLE;
        case 4:
            a = {
                checkedCommercial: !0,
                checkedPartA: !0,
                checkedPartAB: !1,
                checkedPartABD: !1,
                checkedMedicaid: !0,
                checkedOther: !1,
                checkedNone: !0
            }
            if (i.indexOf("checkedCommercial") > -1) {
                if (!o.options.checkedCommercialYes && !o.options.checkedCommercialNo)
                    return f.ERROR;
                if (o.options.checkedCommercialYes)
                    return f.DENIED
            }
            for (var p = 0; p < i.length; p++) {
                if (!a[i[p]])
                    switch (i[p]) {
                        case "checkedPartAB":
                        case "checkedPartABD":
                        case "checkedOther":
                            return f.DENIED1;
                        default:
                            return f.DENIED
                    }
            }
            return f.ELIGIBLE
    }
}